import type { IconProps } from '@tabler/icons-react';
import { typeGlyph } from './typeGlyph.js';

/** A type's glyph as an element, where `typeGlyph`'s component cannot be named inline. */
export const TypeIcon = ({ type, ...props }: { type: string } & IconProps) => {
    const Glyph = typeGlyph(type);
    return <Glyph {...props} />;
};
